import { ExportFormat } from '../../../../../../inspector'
import { ExportFormat as ExportFormatGQL } from '@sketch/gql-types/typemapImports'
import { downloadFile } from '@sketch/components'

import {
  useRenderDownloadableAssetsMutation,
  VersionFragment,
} from '@sketch/gql-types'

export interface IndividualAssetsProps {
  layerOrArtboardId: string
  formats?: ExportFormat['fileFormat'][]
  scales?: number[]
  currentVersion: VersionFragment
}

export type ErrorType = 'default' | 'forbidden' | undefined

// React hook to manage the logic to download layer assets
export function useDownloadLayerAssets({
  layerOrArtboardId,
  formats = [],
  scales = [],
  currentVersion,
}: IndividualAssetsProps) {
  // Mutation to request individual assets, for now this process is
  // synchronously for layer assets so it will return the asset ready to download
  const [renderAssets, { data, loading, error }] =
    useRenderDownloadableAssetsMutation({
      redirectErrors: false,
      variables: {
        documentIdentifier: currentVersion.document?.identifier || '',
        input: {
          layerUuids: [layerOrArtboardId],
          formats: formats as ExportFormatGQL[],
          scales,
        },
      },
      onCompleted: data => {
        const hasError =
          (data.renderDownloadableAssets?.errors?.length ?? 0) > 0
        if (hasError) {
          return
        }
        const asset = data.renderDownloadableAssets?.downloadableAsset
        if (asset?.path) {
          downloadFile(asset.path)
        }
      },
      onError: 'unsafe-throw-exception',
    })

  const shouldShowError =
    (error || data?.renderDownloadableAssets?.errors.length) && !loading

  const errorType: ErrorType = shouldShowError
    ? (data?.renderDownloadableAssets?.errors || []).find(
        error => error?.code === 'FORBIDDEN'
      )
      ? 'forbidden'
      : 'default'
    : undefined

  return { renderAssets, loading, errorType }
}
